module.exports = __webpack_public_path__ + "img/35.8.TSS.b951da09.png";